import React from "react";
import { useEffect, useState } from "react";
import "./BillDetail.css";
import BillOverview from "../../components/BillOverview/BillOverview";
import ContactRepresentative from "../../components/ContactRepresentative/ContactRepresentative";
import Details from "../../components/Details/Details";
import RelatedBills from "../../components/RelatedBills/RelatedBills";
import Background from "../../hero-pattern.svg";
import Loading from "../Loading";
import ContactModal from "../../components/ContactModal/ContactModal";
import { Box, Stack } from "@mui/joy";

function BillDetail() {
  const [loading, setLoading] = useState(false);
  const [bill, setBill] = useState(null);
  const [open, setOpen] = useState(false);
  const params = new URLSearchParams(window.location.search);
  const currentPath = window.location.search;

  useEffect(() => {
    setLoading(true);
    if (localStorage.getItem(currentPath)) {
      var billJson = localStorage.getItem(currentPath);
      var billsArr = JSON.parse(billJson);
      console.log(billsArr);
      setBill(billsArr);
      setLoading(false);
      document.title = `${billsArr.title} | Civic Engage`;
    } else {
      fetch(
        `/api/bill/${params.get("congress")}/${params.get("type")}/${params.get(
          "billIdNumber"
        )}`
      )
        .then((response) => response.json())
        .then((data) => {
          setBill(data);
          localStorage.setItem(currentPath, JSON.stringify(data));
          document.title = `${data.title} | Civic Engage`;
          setLoading(false);
        });
    }
  }, []);

  return (
    <Stack
      className="hero-image"
      direction={"column"}
      sx={{
        alignItems: "center",
        backgroundImage: "url(" + Background + ")",
      }}
    >
      {loading && bill === null ? (
        <Loading></Loading>
      ) : (
        <Stack
          direction={"column"}
          padding={8}
          spacing={1}
          sx={{
            maxWidth: "1280px",
            width: '100%'
          }}
        >
          <BillOverview bill={bill} />
          <Box padding={4} sx={{ paddingBottom: "40px" }}>
            <ContactRepresentative bill={bill} setOpen={setOpen} />
          </Box>
          <Details bill={bill} />
          {bill?.relatedBills?.length > 0 ? (
            <RelatedBills relatedBills={bill.relatedBills} />
          ) : null}
          <ContactModal open={open} setOpen={setOpen} bill={bill} />
        </Stack>
      )}
    </Stack>
  );
}

export default BillDetail;
